import { chatActionTypes } from './constants';

import type {
	AiTutorChatContext,
	TutorConversationData,
	TutorHistoryMessage,
	TutorMessagePayload,
} from '@/features/ai-tutor/types';

export function closeChatInterface(showChat: boolean) {
	return {
		type: chatActionTypes.CLOSE_CHAT_INTERFACE,
		payload: {
			showChat,
		},
	};
}

export function clearChatSession() {
	return {
		type: chatActionTypes.CLEAR_CHAT_SESSION,
	};
}

export function refreshChatInterface() {
	return {
		type: chatActionTypes.REFRESH_CHAT_INTERFACE,
	};
}

export function addUserMessage(text: string, sessionId: string | null, timestamp: string | null) {
	return {
		type: chatActionTypes.ADD_USER_MESSAGE,
		payload: {
			text,
			sessionId,
			timestamp,
		},
	};
}

export function addBotMessage({
	id,
	text,
	complete,
	showLoader,
	inputText,
	sessionId,
	timestamp,
}: {
	id: number;
	text: string;
	complete: boolean;
	showLoader: boolean;
	inputText: TutorMessagePayload | string;
	sessionId: string | null;
	timestamp: string | null;
}) {
	return {
		type: chatActionTypes.ADD_BOT_MESSAGE,
		payload: {
			id,
			text,
			complete,
			showLoader,
			inputText,
			sessionId,
			timestamp,
		},
	};
}

export function removeButtonsFromPreviousMessage() {
	return {
		type: chatActionTypes.REMOVE_BUTTONS_FROM_PREVIOUS_MESSAGE,
	};
}

export function prependChatHistoryMessages(history: TutorHistoryMessage[]) {
	return {
		type: chatActionTypes.PREPEND_CHAT_HISTORY_MESSAGES,
		payload: {
			history,
		},
	};
}

export function openChatInterfaceRequest({
	apiUrl,
	context,
	onRefreshToken,
}: {
	apiUrl: string;
	context: AiTutorChatContext;
	onRefreshToken: () => Promise<boolean>;
}) {
	return {
		type: chatActionTypes.OPEN_CHAT_INTERFACE_REQUEST,
		payload: {
			apiUrl,
			context,
			onRefreshToken,
		},
	};
}

export function loadMoreChatHistoryRequest({
	apiUrl,
	onRefreshToken,
	callback,
}: {
	apiUrl: string;
	onRefreshToken: () => Promise<boolean>;
	callback?: () => void;
}) {
	return {
		type: chatActionTypes.LOAD_MORE_CHAT_HISTORY_REQUEST,
		payload: {
			apiUrl,
			onRefreshToken,
			callback,
		},
	};
}

export function sendChatMessageRequest({
	apiUrl,
	onButtonClick = true,
	messageObj,
	onFirstUserMessage,
	onRefreshToken,
}: {
	apiUrl: string;
	onButtonClick?: boolean;
	messageObj?: TutorMessagePayload;
	onFirstUserMessage: () => void;
	onRefreshToken: () => Promise<boolean>;
}) {
	return {
		type: chatActionTypes.SEND_CHAT_MESSAGE_REQUEST,
		payload: {
			apiUrl,
			onButtonClick,
			messageObj,
			onFirstUserMessage,
			onRefreshToken,
		},
	};
}

export function setChatConversationData(conversationData: Partial<TutorConversationData>) {
	return {
		type: chatActionTypes.SET_CHAT_CONVERSATION_DATA,
		payload: {
			conversationData,
		},
	};
}

export function setChatHistoryLoading(historyLoading: boolean) {
	return {
		type: chatActionTypes.SET_CHAT_HISTORY_LOADING,
		payload: {
			historyLoading,
		},
	};
}

export function setChatSending(sending: boolean) {
	return {
		type: chatActionTypes.SET_CHAT_SENDING,
		payload: {
			sending,
		},
	};
}

export function setChatLastEvaluatedKey(lastEvaluatedKey: string | null) {
	return {
		type: chatActionTypes.SET_CHAT_LAST_EVALUATED_KEY,
		payload: {
			lastEvaluatedKey,
		},
	};
}

export function setChatMessageCounter(messageCounter: number) {
	return {
		type: chatActionTypes.SET_CHAT_MESSAGE_COUNTER,
		payload: {
			messageCounter,
		},
	};
}

export function setChatMessageObj(messageObj: TutorMessagePayload) {
	return {
		type: chatActionTypes.SET_CHAT_MESSAGE_OBJ,
		payload: {
			messageObj,
		},
	};
}

export function resetChatMessageObj() {
	return {
		type: chatActionTypes.RESET_CHAT_MESSAGE_OBJ,
	};
}
